<template>
  <div class="root">
    <div class="params-form">
      <span>发车批次号：</span>
      <div style="flex: 1">
        <el-input v-model="dispatchNumber"></el-input>
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          size="small"
          @click="doSearch"
          >查询</el-button
        >
      </div>
      <el-button
        class="glo_btnItems glo_bgcMainColor"
        size="small"
        @click="printEvent()"
        >打印</el-button
      >
    </div>
    <div class="tab">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="车辆基本信息" name="BaseInfo" v-if="hasPermiss('admin:dispatch:checixiangqing')"> </el-tab-pane>
        <el-tab-pane label="车辆装载明细" name="Bill" v-if="hasPermiss('admin:dispatch:checixiangqing:waybills') || hasPermiss('admin:dispatch:checixiangqing:commands')"> </el-tab-pane>
        <el-tab-pane label="任务模式" name="Task" v-if="hasPermiss('admin:dispatch:checixiangqing:task')"> </el-tab-pane>
        <el-tab-pane label="路线模式" name="Route" v-if="hasPermiss('admin:dispatch:checixiangqing:route')"> </el-tab-pane>
        <el-tab-pane label="配载货物明细" name="Goods" v-if="hasPermiss('admin:dispatch:checixiangqing:goods:info')"> </el-tab-pane>
        <el-tab-pane label="财务信息" name="Finance" v-if="hasPermiss('admin:dispatch:checixiangqing:cai:wu')"> </el-tab-pane>
        <el-tab-pane label="出车确认" name="StartCar" v-if="hasPermiss('admin:dispatch:checixiangqing:chu:che:confirm')"> </el-tab-pane>
        <el-tab-pane label="操作日志" name="Log" v-if="hasPermiss('admin:dispatch:checixiangqing:operation')"> </el-tab-pane>
      </el-tabs>
    </div>
    <div class="children-container">
      <keep-alive>
        <component :is="activeName" :dispatchId="dispatchId" ref="superMan" />
      </keep-alive>
    </div>
    <print ref="printController" :dispatchId="dispatchId" />
  </div>
</template>

<script>
import BaseInfo from "./BaseInfo.vue";
import Bill from "./Bill.vue";
import Task from "./Task.vue";
import Route from "./Route.vue";
import Goods from "./Goods.vue";
import Finance from "./Finance.vue";
import StartCar from "./StartCar.vue";
import Log from "./Log.vue";
import Print from "./Print.vue";
export default {
  props: {
    dispatchNumberX: {},
  },
  components: {
    BaseInfo,
    Bill,
    Task,
    Route,
    Goods,
    Finance,
    StartCar,
    Log,
    Print,
  },
  data() {
    return {
      dispatchNumber: "",
      activeName: this.defaultTab(),
      dispatchInfo: {},
      dispatchId: "",
    };
  },
  mounted() {
    this.dispatchNumber = this.dispatchNumberX;
    if (this.dispatchNumber) {
      this.doSearch();
    }
  },
  watch: {
    dispatchNumberX: {
      handler(val) {
        this.dispatchNumber = val;
        if (val) {
          this.doSearch();
        }
      },
    },
  },
  methods: {
    defaultTab(){
      if(this.hasPermiss('admin:dispatch:checixiangqing')){
        return  'BaseInfo'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:waybills') || this.hasPermiss('admin:dispatch:checixiangqing:commands')){
        return  'Bill'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:task')){
        return  'Task'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:route')){
        return  'Route'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:goods:info')){
        return  'Goods'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:cai:wu')){
        return  'Finance'
      }
      if(this.hasPermiss('admin:dispatch:checixiangqing:chu:che:confirm')){
        return  'StartCar'
      }
      return 'Log'
    },
    async doSearch() {
      if (!this.dispatchNumber) {
        this.$message.warning("请输入发车批次号");
        return;
      }
      const res = await this.$API.runPageReport({
        number: "admin_dispatch_list_v5",
        conditionReqs: [
          { conditonKey: "dispatchNumber", conditonVal: this.dispatchNumber },
        ],
      });
      const data = res.data.result.datas.data;
      if (data == null || data.length == 0) {
        this.$message.warning("没有找到该发车批次号");
        return;
      }
      this.dispatchInfo = data[0];
      this.dispatchId = this.dispatchInfo.dispatchId;
      const superMan = this.$refs.superMan;
      if (superMan.getData) {
        superMan.getData({
          dispatchId: this.dispatchId,
        });
      }
    },
    printEvent() {
      if(!this.dispatchId){
        this.$message.warning("请选择车次")
        return
      }
      this.$refs.printController.printIt();
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
  .params-form {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .el-input {
      width: 200px;
      margin-right: 10px;
    }
  }
  .tab {
    height: 40px;
    .el-tabs {
      //height: 100%;
      overflow: hidden;
      /deep/ .el-tabs__item {
        height: 40px;
        line-height: 40px;
      }
      /deep/ .el-tabs__content {
        height: calc(100% - 71px);
        padding-right: 0;
        display: none;
      }
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  .children-container {
    flex: 1;
    overflow: hidden;
    padding: 10px 10px 0 0;
    /deep/ .el-collapse-item__header {
      font-size: 14px !important;
      font-weight: 100 !important;
    }
  }
}
</style>
<style>
#tab-BaseInfo {
  padding-left: 0;
}
</style>